import { Check } from 'lucide-react'
import React, { useState, useEffect } from 'react'
import { selectInitSessionUserDetails } from '../../../redux/onboardingUserDetails'
import { useDispatch, useSelector } from 'react-redux'
import { fetchSubskillsWithPolling } from '../../../redux/skillSlice'
import { useNavigate } from 'react-router-dom'
import { Mixpanel } from '../../../config/Mixpanel'
import constants from '../../../utilities/constants'

const LoaderOne = () => {
    const [progress, setProgress] = useState(0)
    const [currentStep, setCurrentStep] = useState(0)
    const dispatch = useDispatch()
    const userSessionDetails = useSelector(selectInitSessionUserDetails)
    const navigate = useNavigate()


    useEffect(() => {
        // Track loader page load
        Mixpanel.track(constants.Mixpanel.ONBOARDING_V2_LOADER_ONE_LOADED, {
            session_id: userSessionDetails?.session_id
        })

        const fetchSubskills = async () => {
            await dispatch(fetchSubskillsWithPolling({ 
                session_id: userSessionDetails?.session_id 
            }))
            navigate('/onboarding/3' , { replace: true })
        }

        if(userSessionDetails?.session_id) {
            fetchSubskills()
        }
    }, [dispatch, navigate, userSessionDetails?.session_id])

    useEffect(() => {
        const interval = setInterval(() => {
            setProgress(prev => {
                if (prev >= 100) {
                    return 0 // Reset animation
                }
                return prev + 1
            })
        }, 50)

        return () => clearInterval(interval)
    }, [])

    useEffect(() => {
        const stepInterval = setInterval(() => {
            setCurrentStep(prev => (prev + 1) % 3)
        }, 2000)

        return () => clearInterval(stepInterval)
    }, [])

    return (
        <div className='flex flex-col h-full gap-6 justify-between items-center'>
            <div className="w-full md:max-w-[45rem] flex-1 justify-center items-center mx-auto px-4 pb-4 lg:pb-6 lg:px-6 text-white relative flex flex-col">



                {/* Main Content Container */}
                <div className="w-full mx-auto">

                    {/* Floating Skills Card */}
                    <div className="mx-auto w-[220px] h-[120px] rounded-[16px] relative" style={{
                        backgroundImage: `linear-gradient(
    to bottom,
    rgba(111, 102, 67, 0.15) 0%,
    rgba(64, 106, 255, 0) 100% `}}>
                        <div className='w-full h-full px-6 pt-6  flex flex-col gap-3'>
                            {[0, 1, 2].map((index) => (
                                <div key={index} className="w-full relative">
                                    <div className="w-full bg-[#406AFF]/15 rounded-full h-1 mx-auto max-w-lg overflow-hidden">
                                        <div
                                            className={`h-full rounded-full transition-all duration-1000 ease-out ${index === 0 ? 'bg-blue-500' :
                                                index === 1 ? 'bg-gradient-to-r from-blue-500 to-green-500' :
                                                    'bg-gray-400'
                                                }`}
                                            style={{
                                                width: currentStep >= index ? `${Math.min(progress + (index * 20), 100)}%` : '0%'
                                            }}
                                        ></div>
                                    </div>
                                </div>
                            ))}
                        </div>



                        <div className="absolute -bottom-4 -left-3  w-fit">
                            <div className="w-fit rounded-[12px] px-2 pt-2 pb-3 " style={{ backgroundImage: `linear-gradient(to bottom, #1A70FF 0%, #07162F 100%)` }}>
                                <p className="text-center text-white text-[9px] font-normal mb-4">
                                    Skills used across leading <br /> companies like
                                </p>
                                <div className="flex items-center justify-center">
                                    <img src="https://assets.learntube.ai/files/personalise/Frame%20427323010.webp" alt="" className='w-[42px] h-[20px]' />
                                    <span className="text-white text-[8px] text-white/50 ml-1">+521</span>
                                </div>
                            </div>
                        </div>

                        <div className='absolute top-3 -right-6'>
                            <img src='https://assets.learntube.ai/files/personalise/Frame%2023647.webp' className="w-[45px] h-[45px]" alt="" />
                        </div>

                        <div className='absolute -top-4 right-[40%]'>
                            <img src='https://assets.learntube.ai/files/personalise/Frame%2023648.webp' className="w-[33px] h-[33px]" alt="" />
                        </div>

                        <div className='absolute -top-2 left-2 blur-sm'>
                            <div className='w-full font-medium flex justify-center items-center text-[8px] rounded-[12px] bg-[#153876] px-2 py-[6px]'>
                                dws frwfssv
                            </div>
                        </div>

                        <div className='absolute bottom-2 -right-4 blur-sm'>
                            <div className='w-full font-medium flex justify-center items-center text-[8px] rounded-[12px] bg-[#406AFF]/70 px-2 py-[6px]'>
                                Product Thinking
                            </div>
                        </div>


                    </div>


                    {/* Animated Progress Bars */}


                    {/* Main Title with Gradient Animation */}
                    <div className="mt-16">
                        <div className='flex flex-col'>
                            <h1 className='text-center bg-gradient-to-r from-white to-[#FFE994] bg-clip-text text-transparent font-bold text-[1.75rem] leading-[130%] capitalize'>
                                Selecting The Sub-Skills That Reflect Your Current Level
                            </h1>
                        </div>
                    </div>

                    {/* Bottom Status */}
                    <div className="mt-6 flex items-center justify-center py-3 px-3 rounded-[12px]" style={{ backgroundImage: `linear-gradient(
    to bottom,
    rgba(64, 106, 255, 0.5) 0%,
    rgba(64, 106, 255, 0) 100%
    )` }}>
                        <div className="w-[14px] h-[14px] bg-[#54B226] p-[2px]  rounded-full flex items-center justify-center animate-pulse">
                            <Check className='w-full h-full text-white' />
                        </div>
                        <p className="text-[14px] text-white/50 font-normal ml-1 text-center">
                            Picking the most relevant sub-skills...
                        </p>
                    </div>

                </div>

                {/* Background Animated Elements */}

            </div>



            <div className='capitalize text-center text-[12px] text-[#83BEFF] font-bold mb-3'>BUILT ON REAL-WORLD SKILL FRAMEWORKS</div>
        </div>
    )
}

export default LoaderOne